import $ from 'jquery';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Cookies from 'js-cookie';


$(function() {

  const $checkbox = document.getElementById( 'toggle-menu' );
  const $nav = document.querySelector( '.nav-primary' );

  $checkbox.addEventListener( 'change', ( event ) => {
    if ( event.currentTarget.checked ) {
      disableBodyScroll( $nav );
    } else {
      clearAllBodyScrollLocks();
    }
  })
  
  // CLONE NAV ON SCROLL
  // var $nav = document.querySelector('.nav-primary');
  var $navClone = $nav.cloneNode( true );
  var previousPosition = window.pageYOffset || document.documentElement.scrollTop;
  $navClone.classList.add( 'js-clone' );
  $navClone.classList.add( 'fixed' );
  $nav.parentNode.insertBefore( $navClone, $nav.nextSibling );

  window.addEventListener( 'scroll', function() {

    var height = $navClone.offsetHeight;
    var currentPosition = window.pageYOffset || document.documentElement.scrollTop;

    if ( currentPosition > height ) {
      if ( previousPosition > currentPosition ) {
        $navClone.classList.add( 'scroll-up' );
        $navClone.classList.remove( 'scroll-down' );
      } else {
        $navClone.classList.add( 'scroll-down' );
        $navClone.classList.remove( 'scroll-up' );
      }
    } else {
      $navClone.classList.remove( 'scroll-up' );
      $navClone.classList.remove( 'scroll-down' );
    }

    previousPosition = currentPosition;
  });

  
  // FILTER CUSTOM DROPDOWN
  var dd = document.querySelectorAll( '.dd' );
  var elem = null;
  var dd_selector = '.dd-selection';
  
  dd.forEach(elem => {

    window.onclick = function( event ) {
      if ( !event.target.matches( dd_selector ) && !event.target.closest( '[data-keep-open]' ) ) {
        clearDD()
      }
    }

    elem.querySelector( dd_selector ).addEventListener( "click", function() {
      if ( !elem.classList.contains( 'open' ) ) { clearDD() }
      elem.classList.toggle( "open" );
    })
  })

  function clearDD() {
    for ( var i = 0; i < dd.length; i++ ) {
      if ( dd[i].classList.contains( 'open' ) ) {
        dd[i].classList.remove( 'open' );
      }
    }
  }

})

$( document ).ready( function() {
  if ( window.location.hash.indexOf( 'thanks' ) > -1) {
    dataLayer.push( { 'event': 'register_complete', 'value': 'form_submit' } );
  }
});

let $modal = $( '.notif' );

if ( $modal.length ) {

  if ( $modal.hasClass( 'notif' ) ) {
    $( '.close-notif' ).on(  'click', function( e ) {
      e.preventDefault();
      //removes the class making the modal visable initially
      $modal.removeClass( 'show' ); 

      // cookie doesn't exist yet, create the cookie
      var cookie1Day = 1;

      Cookies.set(  'notif_policy', 'true', {//'name' , 'value' pair
        expires: cookie1Day,
        secure: true //must read on an HTTPS
      });          
    });

    $( '.cookie_track' ).on( 'click', () => {
      //removes the class making the modal visable initially
      $modal.removeClass( 'show' ); 

      // cookie doesn't exist yet, create the cookie
      var cookie1Day = 1;

      Cookies.set(  'notif_policy', 'true', {//'name' , 'value' pair
        expires: cookie1Day,
        secure: true //must read on an HTTPS
      });          
    });

    if ( Cookies.get( 'notif_policy' ) == 'true' ) {
      //if cookie 'notif_policy' exists, dont show the modal
      $modal.removeClass( 'show' );
    } else {
      $modal.addClass( 'show' ); 
    }
  }   
}

$( document ).ready( function() {
  $( '.cookie_track' ).on( 'click', () => { {
      dataLayer.push( { 'event': 'notif_conversion', 'value': 'notification' } );
    }
  });
})